import { render, staticRenderFns } from "./SampleClassificationHeat.vue?vue&type=template&id=5216c3fa&scoped=true"
import script from "./SampleClassificationHeat.vue?vue&type=script&lang=js"
export * from "./SampleClassificationHeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216c3fa",
  null
  
)

export default component.exports